export default __webpack_public_path__ + "static/media/who-has-the-spotlight-screenshot.3e81bacb.png";